// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3922": "a498f753","4014": "d127c5ad","5347": "9ed1b558","5633": "b5eee60f","7595": "8b166599","8024": "4920602b","8184": "d42360ab","8635": "0bda8241",}[chunkId] + ".css"
}